import LocaleService from 'infrastructure/i18n/LocaleService';
import {
  ColumnAlign,
  ColumnInfo
} from 'modules/inbound/shared/domain/ColumnsTypes';
import { EntriesText } from '../../entries/infrastructure/i18n/EntriesText';
import { EntriesTranslations } from '../../entries/infrastructure/i18n/typing';
import { SistemAlertsDataDTO } from '../infractructure/dto/SistemAlertsDTO';

const entriesTranslations: EntriesTranslations = {
  ...EntriesText[LocaleService.getLanguage()]
};

export interface ColumnsInfo {
  key: string;
  uiKey: string;
  value: string;
  sortable: boolean;
  isVisibleCheck: boolean;
  draggable: boolean;
  align?: ColumnAlign;
}
export interface SystemAlarmsColumns extends ColumnInfo {
  key:
    | keyof SistemAlertsDataDTO
    | 'plate_number'
    | 'supplier_number'
    | 'current_point'
    | 'warehouse_capacity_alert'
    | 'coverage_alert'
    | 'dlz_alert';
  uiKey: TColumnKeys;
  isVisibleCheck: boolean;
}

export const SYSTEM_ALARMS_COLUMN_KEYS = {
  actualLocation: 'actualLocation',
  capacity: 'capacity',
  coverage: 'coverage',
  dlz: 'dlz',
  licensePlate: 'licensePlate',
  providerName: 'providerName'
} as const;

type TColumnKeys =
  (typeof SYSTEM_ALARMS_COLUMN_KEYS)[keyof typeof SYSTEM_ALARMS_COLUMN_KEYS];

export interface SystemAlarmsColumn extends ColumnInfo {
  key:
    | keyof SistemAlertsDataDTO
    | 'plate_number'
    | 'supplier_number'
    | 'current_point'
    | 'warehouse_capacity_alert'
    | 'coverage_alert'
    | 'dlz_alert';
  uiKey: TColumnKeys;
  isVisibleCheck: boolean;
}

const SORTABLE_COLUMNS: TColumnKeys[] = [
  'actualLocation',
  'capacity',
  'coverage',
  'dlz',
  'licensePlate',
  'providerName'
];

const RIGHT_ALIGNED_COLUMNS: TColumnKeys[] = [
  // Añade aquí las columnas numéricas que quieras alinear a la derecha
  'actualLocation',
  'capacity',
  'coverage',
  'dlz',
  'licensePlate',
  'providerName'
];

const getColumnAlignment = (
  column: TColumnKeys
): SystemAlarmsColumn['align'] => {
  return RIGHT_ALIGNED_COLUMNS.includes(column) ? 'right' : 'left';
};

export const SYSTEM_ALARMS_COLUMNS: SystemAlarmsColumns[] = [
  /**
   * Matrícula
   * Descripción funcional: Matrícula del camión
   */
  {
    key: 'license_plate', // ajustar al campo real del DTO si es distinto
    uiKey: 'licensePlate',
    value: entriesTranslations.plateNumber,
    sortable: SORTABLE_COLUMNS.includes('licensePlate'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('licensePlate')
  },
  /**
   * Número Proveedor
   * Descripción funcional: Proveedor asociado
   */
  {
    key: 'provider_name', // ajustar al campo real del DTO
    uiKey: 'providerName',
    value: entriesTranslations.supplierName,
    sortable: SORTABLE_COLUMNS.includes('providerName'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('providerName')
  },
  /**
   * Punto actual
   * Descripción funcional: Muelle asociado (T12A, T12K..)
   */
  {
    key: 'actual_location', // ajustar al campo real del DTO
    uiKey: 'actualLocation',
    value: entriesTranslations.currentPoint,
    sortable: SORTABLE_COLUMNS.includes('actualLocation'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('actualLocation')
  },
  /**
   * Cap.Almacen
   * Descripción funcional: Alerta por capacidad almacén
   */
  {
    key: 'capacity', // ajustar al campo real del DTO
    uiKey: 'capacity',
    value: entriesTranslations.warehouseCapacityAlert,
    sortable: SORTABLE_COLUMNS.includes('capacity'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('capacity')
  },
  /**
   * Cobertura
   * Descripción funcional: Alerta por cobertura
   */
  {
    key: 'coverage', // ajustar al campo real del DTO
    uiKey: 'coverage',
    value: entriesTranslations.coverageAlert,
    sortable: SORTABLE_COLUMNS.includes('coverage'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('coverage')
  },
  /**
   * DLZ
   * Descripción funcional: Alerta por dlz
   */
  {
    key: 'dlz', // ajustar al campo real del DTO
    uiKey: 'dlz',
    value: entriesTranslations.dlzAlert,
    sortable: SORTABLE_COLUMNS.includes('dlz'),
    isVisibleCheck: true,
    draggable: true,
    align: getColumnAlignment('dlz')
  }
];
